import React from 'react';
import { ServiceLandingPage } from '../components/ServiceLandingPage';
export function HomeBuyers() {
  return <ServiceLandingPage badge="Home Buyers" heroHeadline="Make Your Next Move Without Closing Doors" heroSub="Upgrade, refinance or restructure — without limiting your future options." heroCta="Map Your Next Move" problems={['Should I sell or keep my property?', 'Is my current loan holding me back?', 'Can I use equity?', 'Am I structured correctly?']} videoSectionTitle="Home Buyer & Refinance Series" videos={[{
    title: 'When to refinance',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Using equity properly',
    id: 'dQw4w9WgXcQ'
  }, {
    title: 'Sell vs hold explained',
    id: 'dQw4w9WgXcQ'
  }]} howWeHelp={['Review full position', 'Optimise structure', 'Plan next move']} process={[{
    title: 'Review your current loans and property',
    description: 'Understand where you stand today.'
  }, {
    title: 'Assess equity and options',
    description: 'See what capital you have available.'
  }, {
    title: 'Decide keep vs sell strategy',
    description: 'Model out the financial impact of both.'
  }, {
    title: 'Structure next move',
    description: 'Set up the lending to support your decision.'
  }, {
    title: 'Execute refinance or purchase',
    description: 'Handle the process from start to finish.'
  }]} scenario="Client upgraded while keeping investment property using equity" finalCta="Explore Your Options" data-id="element-1612" />;
}